'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _axiosCacheAdapter = require('axios-cache-adapter');

var _TopTabs = require('./TopTabs');

var _TopTabs2 = _interopRequireDefault(_TopTabs);

var _Collections = require('./Collections');

var _Collections2 = _interopRequireDefault(_Collections);

var _MyCollection = require('./MyCollection');

var _MyCollection2 = _interopRequireDefault(_MyCollection);

var _Modal = require('./Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ls = require('localstorage-ttl');

var App = function (_React$Component) {
	_inherits(App, _React$Component);

	function App(props) {
		_classCallCheck(this, App);

		var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

		_this.handleCloseModal = function (event) {
			event.preventDefault();
			_this.setState({ modal: false });
		};

		_this.escCloseModal = function (event) {
			// listen to escape when modal is opened
			if (event.keyCode === 27 && _this.state.modal) {
				_this.setState({ modal: false });
			}
		};

		_this.getUserCollection = function () {
			// get saved collections
			_this.api(iconPressConfig.rest_url + 'get_user_collections').then(function (response) {
				_this.setState({
					selected: response['default'] || [],
					originalSelected: response['default'] || []
				});
			});
		};

		_this.toggleSelected = _this.toggleSelected.bind(_this);
		_this.updateSearchTerm = _this.updateSearchTerm.bind(_this);
		_this.updateSize = _this.updateSize.bind(_this);
		_this.handleSave = _this.handleSave.bind(_this);
		_this.handleModal = _this.handleModal.bind(_this);
		_this.refreshSearchCache = _this.refreshSearchCache.bind(_this);
		_this.api = _this.api.bind(_this);
		_this.checkForUnsaved = _this.checkForUnsaved.bind(_this);

		// initial state
		_this.state = {
			selected: [],
			originalSelected: [],
			searchTerm: '',
			size: parseFloat(iconPressConfig.grid_icon_size),
			modal: false,
			isSaving: false,
			active: window.location.hash === '#iconfinder' ? 'iconFinder' : _this.props.active
		};

		_this.saveOptionsEndpoint = iconPressConfig.rest_url + 'ajax_save_collection';

		return _this;
	}

	_createClass(App, [{
		key: 'toggleSelected',
		value: function toggleSelected(icon) {
			var _this2 = this;

			var newSel = [].concat(_toConsumableArray(this.state.selected));
			var isSelected = newSel.some(function (el) {
				return el.internal_id === icon.internal_id;
			});

			if (newSel.length === 0) {
				this.setState({
					selected: [].concat(_toConsumableArray(newSel), [icon])
				});
			} else {
				if (isSelected) {
					newSel.filter(function (s, i) {
						if (s.internal_id === icon.internal_id) {
							newSel.splice(i, 1);
							_this2.setState({
								selected: newSel
							});
						}
					});
				} else {
					this.setState({
						selected: [].concat(_toConsumableArray(newSel), [icon])
					});
				}
			}
		}
	}, {
		key: 'updateSearchTerm',
		value: function updateSearchTerm(newSearchTerm) {
			this.setState({
				'searchTerm': newSearchTerm
			});

			if (newSearchTerm === '') {
				this.refreshSearchCache();
			}
		}
	}, {
		key: 'updateSize',
		value: function updateSize(event) {
			this.setState({ 'size': event.target.value });
		}

		// Method for getting/setting data
		// from the provided end point url

	}, {
		key: 'api',
		value: function api(endPoint, method, data, headers) {

			var cache = (0, _axiosCacheAdapter.setupCache)({
				maxAge: 15 * 60 * 1000
			});

			var ax = _axios2.default.create({
				adapter: cache.adapter
			});

			method = method || 'get';

			var ax_options = {
				url: endPoint || '',
				method: method
			};

			if (!headers) {
				ax_options.headers = { 'X-WP-Nonce': iconPressConfig.rest_nonce };
			} else {
				ax_options.headers = headers;
			}

			if (data) {
				ax_options.data = data;
			}

			return new Promise(function (resolve, reject) {
				ax(ax_options).then(function (response) {
					resolve(response.data);
				}).catch(function (error) {
					reject(error);
					// show errors in console on Debug mode
					if (iconPressConfig.debug === '1') {
						console.log('Error: ', error);
					}
				});
			});
		}
	}, {
		key: 'handleSave',
		value: function handleSave(event, redirect) {
			var _this3 = this;

			event.preventDefault();

			var data = {
				icons: this.state.selected
			};

			this.setState({
				isSaving: true
			});

			this.api(this.saveOptionsEndpoint, 'post', data).then(function (response) {

				_this3.setState({
					isSaving: false
				});

				if (!response.success) {
					_this3.handleModal('error', response.data);
					return false;
				} else {

					// remove cache
					localStorage.removeItem(iconPressConfig.plugin_slug + '_myCollection');

					// Show confirmation
					_this3.handleModal('confirmation-save', iconPressConfig.translations.COLLECTION_SAVED);

					// update original state
					_this3.setState({
						selected: response.data,
						originalSelected: response.data
					});

					_this3.resetSvgContents();

					// Trigger save event
					window.parent.dispatchEvent(new CustomEvent('iconpress:save'));

					// Redirect to my collection
					if (redirect) {
						_this3.setState({
							active: 'myCollection'
						});
					}
				}
			});

			return true;
		}
	}, {
		key: 'resetSvgContents',
		value: function resetSvgContents() {
			// reset the SVG sprite with the newly added HTML
			// used in My Collection page
			var svgSprite = document.getElementById('iconpress_svg_sprite');
			// empty HTML
			svgSprite.innerHTML = "";
			// add new HTML
			this.api(iconPressConfig.rest_url + 'get_svg_sprite_content', 'get').then(function (resp) {
				if (resp.success && resp.data) {
					var tempDiv = document.createElement("div");
					tempDiv.innerHTML = resp.data;
					svgSprite.innerHTML = tempDiv.childNodes[0].innerHTML;
				} else {
					console.log('Couldn\'t reload svg sprite.');
				}
			});
		}
	}, {
		key: 'handleModal',
		value: function handleModal(type, message) {

			if (type) {

				this.setState({
					modal: {
						'type': type,
						'content': message
					}
				});

				if (type == 'confirmation-save') {
					// reset modal
					setTimeout(function () {
						this.setState({
							modal: false
						});
					}.bind(this), 1100);
				}
			}
		}
	}, {
		key: 'refreshSearchCache',
		value: function refreshSearchCache() {
			var paneOptions = iconPressConfig.panes;
			if (paneOptions && paneOptions.length !== 0) {
				paneOptions.map(function (pane) {
					return localStorage.removeItem(iconPressConfig.plugin_slug + '_search_' + pane.type);
				});
			}
		}
	}, {
		key: 'checkSelected',
		value: function checkSelected() {
			return !_.isEqual(this.state.selected, this.state.originalSelected);
		}
	}, {
		key: 'checkForUnsaved',
		value: function checkForUnsaved(event) {
			if (this.checkSelected() && iconPressConfig.debug === '0') {
				(event || window.event).returnValue = iconPressConfig.translations.LEAVE_CONFIRM; //Gecko + IE
				return true; //Gecko + Webkit, Safari, Chrome etc.
			}
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			// finished loading the app and add class
			// to remove the page preloader
			document.body.classList.add("iconpressApp--loaded");

			// cleanup search cache
			this.refreshSearchCache();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {

			var appWrapper = document.querySelector('.ip-appWrapper');
			var topAppWrapperPos = appWrapper.offsetTop;
			var headerHeight = appWrapper.querySelector('.ip-header').offsetHeight;
			var startsAt = topAppWrapperPos + headerHeight;
			// add a minimum height to the panes
			appWrapper.querySelector('.ip-panes').style.minHeight = 'calc((100vh - 65px) - ' + startsAt + 'px';

			// get saved collection
			this.getUserCollection();

			// check for unsaved
			window.addEventListener('beforeunload', this.checkForUnsaved);

			// close modal
			document.addEventListener("keydown", this.escCloseModal, false);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.checkForUnsaved();
			window.removeEventListener('beforeunload', this.checkForUnsaved);
			document.removeEventListener("keydown", this.escCloseModal, false);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var paneOptions = iconPressConfig.panes;

			if (!paneOptions && paneOptions.length === 0) {
				if (iconPressConfig.debug === '1') {
					console.log('Panes are missing.');
				}
				return;
			}

			var tabPanes = {};

			{
				paneOptions.length !== 0 && paneOptions.map(function (pane) {
					return tabPanes[pane.id] = _react2.default.createElement(_Collections2.default, {
						key: pane.id,

						options: pane,
						api: _this4.api,

						size: _this4.state.size,
						updateSize: _this4.updateSize,

						updateSearchTerm: _this4.updateSearchTerm,
						searchTerm: _this4.state.searchTerm,

						selected: _this4.state.selected,
						toggleSelected: _this4.toggleSelected,

						handleSave: _this4.handleSave,
						handleModal: _this4.handleModal,

						refreshSearchCache: _this4.refreshSearchCache,
						context: _this4.props.context
					});
				});
			};

			tabPanes['myCollection'] = _react2.default.createElement(_MyCollection2.default, {
				api: this.api,
				selected: this.state.selected,
				handleModal: this.handleModal,
				resetSvgContents: this.resetSvgContents,
				toggleSelected: this.toggleSelected,
				context: this.props.context
			});

			// wrapper custom classes
			var classes = [
			// when save is in progress
			this.state.isSaving ? 'is-saving' : '',
			// icon sizes
			'ip-icon-size-' + this.state.size,
			// if there are changes
			this.checkSelected() ? 'has-changes' : '',
			// app context
			'iconpressApp-' + this.props.context];

			return _react2.default.createElement(
				'div',
				{ className: 'ip-appWrapper ' + classes.join(' ') },
				_react2.default.createElement(
					'div',
					{ className: 'ip-header' },
					_react2.default.createElement(
						_TopTabs2.default,
						{
							active: this.state.active,
							onChange: function onChange(active) {
								return _this4.setState({ active: active });
							} },
						paneOptions.length !== 0 && paneOptions.map(function (pane) {
							return _react2.default.createElement(
								'span',
								{ key: pane.id },
								pane.title
							);
						}),
						_react2.default.createElement(
							'span',
							{ key: 'myCollection' },
							iconPressConfig.translations.MY_COLLECTION
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'ip-panes' },
					tabPanes[this.state.active]
				),
				this.state.modal && _react2.default.createElement(
					_Modal2.default,
					{ className: 'ip-msgModal ip-modal--' + this.state.modal.type, closeModal: this.handleCloseModal },
					this.state.modal.content
				)
			);
		}
	}]);

	return App;
}(_react2.default.Component);

App.propTypes = {
	selected: _propTypes2.default.array,
	originalSelected: _propTypes2.default.array
};

exports.default = App;


//////////////////
// WEBPACK FOOTER
// ./src/components/App.js
// module id = 108
// module chunks = 0 1